"use client";

import dynamic from "next/dynamic";

const CorporateContactSectionEn = dynamic(
  () => import("@/sections/remind/corporate-contact-section-en"),
  { ssr: false }
);

export default CorporateContactSectionEn;
